import { remToPixels } from "@utils/helpers/style";
import { useEffect, useMemo, useState } from "react";
import variables from '../../styles/_styles.module.scss'

type WindowSizeType = {
  width?: number;
  height?: number
}

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSizeType>({
    width: undefined,
    height: undefined,
  });

  const isMobile = useMemo(() => {
    return (windowSize.width || 0) < remToPixels(variables['break-point-lg']);
  }, [windowSize])


  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { ...windowSize, isMobile };
}

export default useWindowSize;